/**
 *
 * PageHeader
 *
 */
import * as React from 'react';
import fonts from 'app/assets/styles/fonts';
import IconText, { IconTextStyleProps } from '../IconText';
import { useTheme } from '@mui/material';

interface Props extends IconTextStyleProps {
  icon: React.ReactNode;
  text: React.ReactNode;
}

export function PageHeader(props: Props) {
  const theme = useTheme();
  return (
    <>
      <IconText
        text={props.text}
        icon={props.icon}
        textStyle={{
          fontSize: fonts.xlarge,
          color: theme.palette.asseticPrimary.main,
          fontWeight: 'bold',
          lineHeight: 'unset',
          ...props.textStyle,
        }}
        iconStyle={{
          '& svg': { fontSize: 50 },
          ...props.iconStyle,
        }}
        wrapperStyle={{
          alignItems: 'center',
          paddingBottom: theme.spacing(2),
          ...props.wrapperStyle,
        }}
      />
    </>
  );
}
